import React from 'react'
import { Modal } from 'antd'
import { useHistory } from 'react-router-dom'
import './PurchaseModal.scss'
import BuyNowIcon from '../../../assets/images/Icons/BuyNowIcon'

const PurchaseModal = ({ setShowPurchaseModal }) => {
  const history = useHistory()
  return (
    <Modal
      className="purchase-course-modal"
      visible={true}
      footer={[
        <div className="d-flex align-items-center justify-content-center modal-button-wrapper">
          <button
            className="modal-btn-buy-now"
            onClick={() => {
              history.push('/education/get-accredited/course-details')
              setShowPurchaseModal(false)
            }}
          >
            Buy Now
          </button>
        </div>,
      ]}
      onCancel={() => {
        setShowPurchaseModal(false)
      }}
    >
      {/* <img src={BuyNow} /> */}
      <BuyNowIcon />
      <h1>You're Almost There!</h1>
      <p>Purchase the course to start learning.</p>
    </Modal>
  )
}

export default PurchaseModal
